export const eWalletData = {
    balance: 1500, // Energy points
    transactions: [
      { date: '01/15/2023', energySentToGrid: 120, pointsEarned: 1200 },
      { date: '02/20/2023', energySentToGrid: 150, pointsEarned: 1500 },
      { date: '03/10/2023', energySentToGrid: 100, pointsEarned: 1000 },
      { date: '04/25/2023', energySentToGrid: 200, pointsEarned: 2000 },
      { date: '05/05/2023', energySentToGrid: 180, pointsEarned: 1800 },
    ],
  };